<template>
  <div>
    <LeftSide
      :status="leftSideStatus"
      @changeStatus="changeLeftSideStatus"
      :supplier_id="filters.supplierId"
      :supplier_name="filters.supplierName"
      :supplier_contacts="filters.supplierContacts"
      :supplier_status="filters.status"
      :subUser="subUserList"
      :subUserId="filters.subUserId"
      :dateFrom="filters.dateFrom"
      :dateTo="filters.dateTo"
      :dateType="filters.dateType"
      :subUserName="filters.subUserName"
      :sku="filters.sku"
      :key_type="filters.type"
      @filtrate="filtrate"
      @batchSearch="batchSearch"
    />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :batchBool="batchBool"
        :supplier_id="filters.supplierId"
        :supplier_name="filters.supplierName"
        :supplier_contacts="filters.supplierContacts"
        :supplier_status="filters.status"
        :subUser="subUserList"
        :subUserId="filters.subUserId"
        :dateFrom="filters.dateFrom"
        :dateTo="filters.dateTo"
        :dateType="filters.dateType"
        :subUserName="filters.subUserName"
        :sku="filters.sku"
        :key_type="filters.type"
        @clearKey="clearKey"
      />
      <router-view
        v-if="isSysRights('OutOfStockList.findBySupplier')"
        :first_loading="firstLoading"
        :items="items"
        @openEdit="openEdit"
        @openLog="openLog"
        @confirmDate="confirmDate"
      ></router-view>
      <no-rights v-else></no-rights>
      <pagination
        class="pd-x-20 pd-sm-x-30"
        v-if="!firstLoading"
        :cur="page"
        :all="totalPage"
        :path="'/stock-out/'"
        :page_size_select="pageSizeSelect"
        :rows_per_page="rowsPerPage"
        :total_count="totalCount"
        @changeRPPage="changeRPPage"
        @gotoPage="toPage"
      />
    </div>
    <api-loading :show="loading"></api-loading>
    <modalEditDate :open="editOpen" :info="editInfo"></modalEditDate>
    <modalStockLog :info="logInfo"></modalStockLog>
    <batch-search-dialog @handleBatchSearch="handleBatchSearch" :dialog="batchSearchDialog" v-if="batchSearchDialog.visible"></batch-search-dialog>
    <confirm-date-dialog :dialog="confirmDateDialog" v-if="confirmDateDialog.visible"></confirm-date-dialog>
  </div>
</template>

<script>
import { pagination } from "@components/pagination.js"; //分页
import LeftSide from "./left-side.vue"; //左边栏
import Header from "./header.vue"; //头
import modalEditDate from "./modal-edit-date.vue";
import modalStockLog from "./modal-log.vue";
import BatchSearchDialog from '../../distributor/batch-search-dialog.vue'
import ConfirmDateDialog from './confirm-date-dialog.vue'

export default {
  components: {
    BatchSearchDialog,
    LeftSide,
    Header,
    pagination,
    modalEditDate,
    modalStockLog,
    ConfirmDateDialog,
  },
  data() {
    return {
      firstLoading: false,
      loading: true,
      leftSideStatus: store.get("leftSideStatus"), //左边栏状态
      pageSizeSelect: [10, 20, 50],
      page: this.$route.params.page ? this.$route.params.page : 1,
      rowsPerPage: parseInt(store.get("stockout-filter-rowsPerPage"))
        ? parseInt(store.get("stockout-filter-rowsPerPage"))
        : 10,
      totalPage: 0,
      totalCount: 0,
      items: [],
      filters: {
        supplierId: "",
        supplierName: "",
        supplierContacts: "",
        status: "",
        subUserId: "",
        dateType: "",
        dateFrom: "",
        dateTo: "",
        sku: "",
        subUserName: "",
        type: "",
      },
      subUserList: [],
      cancelOpen: Symbol(),
      cancelInfo: "",
      editOpen: Symbol(),
      editInfo: "",
      logInfo: "",
      batchSearchDialog:{
        visible: false,
        key: '',
      },
      batchSearchParams: {},
      batchBool: false,
      confirmDateDialog: {
        visible: false,
        row: {}
      }
    };
  },
  mounted() {
    //展开折叠搜索
    let user = store.get("userInfo");
    let that = this;
    if (this.$parent.sideTop) {
      if ($(".br-subleft").outerHeight() > 56) {
        $(".br-subleft").addClass("left-more ht-54 ht-auto");
        $(".br-subleft").append(
          `<a href="javascript:;" class="d-flex align-items-center more-btn"><span class=" mg-r-5 tx-info">${this.$t(
            "app.更多"
          )}</span><i aria-hidden="true" class="tx-info fa fa-angle-down"></i></a>`
        );
        $(".more-btn").on("click", function () {
          if ($(this).find("i").hasClass("fa-angle-down")) {
            $(this).find("span").text(that.$t("app.隐藏"));
            $(this).parent(".br-subleft").removeClass("ht-54");
            $(this)
              .find("i")
              .removeClass("fa-angle-down")
              .addClass("fa-angle-up");
          } else {
            $(this).find("span").text(that.$t("app.更多"));
            $(this).parent(".br-subleft").addClass("ht-54");
            $(this)
              .find("i")
              .addClass("fa-angle-down")
              .removeClass("fa-angle-up");
          }
          let bodyH = parseInt($(window).height());
          if (user.source == 9) {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 340 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 340 + "px");
            }
          } else {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 260 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 260 + "px");
            }
          }
        });
      }
    }
    this.getStockoutList();
  },
  watch: {
    $route: "gotoPage",
    rowsPerPage: function () {
      store.set("stockout-filter-rowsPerPage", this.rowsPerPage);
    },
  },
  methods: {
    confirmDate(item) {
      this.confirmDateDialog = {
        visible: true,
        row: item
      }
    },
    batchSearch(key){
      this.batchSearchDialog = {
        visible: true,
        key: key
      }
    },
    openLog(i) {
      this.logInfo = this.items[i];
      $("#modalStockLogSu").modal("show");
    },
    openEdit(i) {
      this.editOpen = Symbol();
      this.editInfo = this.items[i];
      $("#modalEditDateSu").modal("show");
    },
    handleBatchSearch(item){
      this.batchSearchParams = item
      this.batchBool = true
      this.page = 1
      this.rowsPerPage = 10
      this.getStockoutList()
    },

    getStockoutList(batch) {
      if (!this.isSysRights("OutOfStockList.findBySupplier")) return;
      if(batch == 'common') {
        this.batchBool = false
      }
      this.loading = true;
      this.firstLoading = true;
      let vm = this;
      let params = {
        page: this.page,
        rowsPerPage: this.rowsPerPage,
        supplierId: this.filters.supplierId,
        status: this.filters.status,
        subUserId: this.filters.subUserId,
        sku: this.filters.sku,
        dateType: this.filters.dateType,
        dateFrom: this.filters.dateFrom,
        dateTo: this.filters.dateTo,
        type: this.filters.type,
      };
      let getData = (data) => {
        this.items = data.Results ? data.Results : [];
        this.totalPage = data.Pagination.totalPage;
        this.totalCount = data.Pagination.totalCount;
        $("html,body").scrollTop(0);
      };
      if(Object.keys(this.batchSearchParams).length !== 0 && this.batchBool){
        params = {
          batchSearch: this.batchSearchParams,
          page: this.page,
          rowsPerPage: this.rowsPerPage,
        }
      }
      $.api_call("api.OutOfStockList.findBySupplier", params, function (r) {
        vm.loading = false;
        vm.firstLoading = false;
        if (r.ErrorCode == "9999") {
          if(Object.keys(vm.batchSearchParams).length !== 0){
              vm.batchSearchDialog.visible = false
            }
          getData(r.Data);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(vm);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    filtrate(
      type,
      name,
      id,
      contact,
      status,
      subUserId,
      subUserName,
      sku,
      dateType,
      dateFrom,
      dateTo
    ) {
      this.filters.supplierName = name;
      this.filters.supplierId = id;
      this.filters.supplierContacts = contact;
      this.filters.status = status;
      this.filters.subUserId = subUserId;
      this.filters.sku = sku;
      this.filters.dateType = dateType;
      this.filters.dateFrom = dateFrom;
      this.filters.dateTo = dateTo;
      this.filters.subUserName = subUserName;
      this.filters.type = type;
      //筛选都回第一页
      this.toPage(1);
    },
    changeLeftSideStatus() {
      //改变左边栏状态
      this.leftSideStatus = !this.leftSideStatus;
      store.set("leftSideStatus", this.leftSideStatus);
    },
    changeRPPage(num) {
      let page = this.page;
      this.rowsPerPage = num;
      this.page = 1;
      this.$router.replace({ path: "/stock-out/" + 1 });
      if (page == 1) {
        this.getStockoutList();
      }
    },
    toPage(num) {
      let page = this.page;
      this.$router.replace({ path: "/stock-out/" + num });
      if (page == num) {
        this.getStockoutList('common');
      }
    },
    gotoPage() {
      this.page = this.$route.params.page ? this.$route.params.page : 1;
      this.getStockoutList();
    },
    clearKey(type) {
      switch (type) {
        case "name":
          this.filters.supplierName = this.filters.supplierId = "";
          break;
        case "batchBool":
          this.getStockoutList('common');
          break;
        case "contacts":
          this.filters.supplierContacts = this.filters.supplierId = "";
          break;
        case "status":
          this.filters.status = "";
          break;
        case "subUserName":
          this.filters.subUserId = this.filters.subUserName = "";
          break;
        case "date":
          this.filters.dateType =
            this.filters.dateFrom =
            this.filters.dateTo =
              "";
          break;
        case "sku":
          this.filters.sku = "";
          break;
        case "type":
          this.filters.type = "";
          break;
      }
      this.toPage(1);
    },
  },
};
</script>
